import React from "react";

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export const AppleIcon: React.FC<SvgIconProps> = ({ ...props }) => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 14 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Shape</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="App-Store" fill={props?.color || "#000000"} fillRule="nonzero">
        <g id="Apple_logo_black">
          <path
            d="M13.5040204,12.4688577 C13.2563793,13.0278532 12.9632531,13.5424055 12.623631,14.0154776 C12.1606938,14.6603964 11.7816513,15.1068027 11.4895359,15.3546964 C11.0367065,15.7615977 10.5515321,15.9699865 10.0319912,15.981838 C9.65901338,15.981838 9.20921629,15.8781374 8.68563227,15.6677734 C8.16032992,15.458397 7.67758141,15.3546964 7.23617379,15.3546964 C6.77323657,15.3546964 6.27674145,15.458397 5.74567765,15.6677734 C5.21380523,15.8781374 4.7853356,15.9877637 4.45774182,15.9986276 C3.95952837,16.0193677 3.46293217,15.8050532 2.96724568,15.3546964 C2.65087155,15.0850749 2.25515119,14.6228667 1.78109538,13.9680717 C1.2724709,13.2688335 0.854311229,12.4579938 0.526717442,11.5335773 C0.175875714,10.535089 0,9.56820464 0,8.63213417 C0,7.55987028 0.237128981,6.63505872 0.712094488,5.8600698 C1.08537553,5.2375701 1.58197173,4.74652321 2.20350033,4.38604028 C2.82502893,4.02555735 3.49659114,3.84185919 4.21980421,3.83010646 C4.61552457,3.83010646 5.13445901,3.94970779 5.77933663,4.18476241 C6.42239484,4.42060713 6.83529846,4.54020846 7.01632915,4.54020846 C7.15167259,4.54020846 7.61036454,4.40036083 8.38795757,4.12155444 C9.12329999,3.86299436 9.7439189,3.75593587 10.2523412,3.79810743 C11.6300343,3.90674612 12.665073,4.43739675 13.3534142,5.39341724 C12.1212734,6.12287667 11.5117731,7.14457419 11.5239024,8.45525063 C11.535021,9.47615804 11.9140635,10.3257126 12.6590083,11.0002601 C12.9966088,11.3133371 13.3736298,11.5553051 13.7931034,11.7271517 C13.7021333,11.9849217 13.6061092,12.2318278 13.5040204,12.4688577 Z M10.3443222,0.320089091 C10.3443222,1.12027231 10.0451313,1.86740035 9.44877114,2.55893501 C8.72909581,3.38103362 7.8586121,3.85608099 6.91464469,3.78112029 C6.9026164,3.68512319 6.89564202,3.58408921 6.89564202,3.47791958 C6.89564202,2.70974526 7.23789212,1.88764665 7.84567411,1.21546944 C8.14911026,0.875134044 8.53502605,0.592150004 9.00301718,0.366408679 C9.46999752,0.144035153 9.91170837,0.0210561537 10.3271389,0 C10.3392683,0.106969607 10.3443222,0.213949089 10.3443222,0.320079215 L10.3443222,0.320089091 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
